import * as z$1 from "zod/v4";
//#region src/schemas/daemon/reply-readiness.ts
const REPLY_READINESS_LEVEL_VALUES = [
	"blocked",
	"degraded",
	"ready",
	"unknown"
];
const REPLY_READINESS_REASON_CODE_VALUES = [
	"service.not_installed",
	"service.drifted",
	"service.not_running",
	"service.account_mismatch",
	"service.auth_missing",
	"service.auth_stale",
	"dispatch.storage_not_ready",
	"service.gateway_chain_unhealthy",
	"profile.not_selected",
	"profile.inactive",
	"profile.unbound",
	"controller.binding.disabled",
	"projection.missing",
	"controller.registry.disabled",
	"controller.launch.choice_required",
	"controller.launch.needs_repair",
	"workspace.missing",
	"workspace.invalid",
	"runtime.adapter.unsupported",
	"controller.bootstrap.failed",
	"controller.gateway.unhealthy",
	"local_agents.none_needed",
	"route.offline",
	"route.not_registered"
];
const replyReadinessLevelSchema = z$1.enum(REPLY_READINESS_LEVEL_VALUES);
const replyReadinessReasonCodeSchema = z$1.enum(REPLY_READINESS_REASON_CODE_VALUES);
//#endregion
export { REPLY_READINESS_LEVEL_VALUES, REPLY_READINESS_REASON_CODE_VALUES, replyReadinessLevelSchema, replyReadinessReasonCodeSchema };

//# sourceMappingURL=reply-readiness.js.map